
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import navigationReducer from "./navigation_reducer";
import {History} from "history";


const createRootReducer: (history: History) => any = (history: History) => combineReducers<{router: any, app: any}>({
    router: connectRouter(history),
    app: navigationReducer
});

export default createRootReducer;
